import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-session-timeout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.css']
})
export class SessionTimeoutComponent {

  constructor(private router: Router) {}

  goToLogin() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
}